// Limpia lo que se escribe en un campo de cédula de las tablas de registro
// masivo: solo dígitos, salvo la "F" inicial de las cédulas falsas que genera
// el sistema (F + 7 dígitos, ver /datos-codigo-falso). Antes se borraba
// cualquier letra y la cédula falsa no se podía escribir (punto 6 de José,
// 25/09/2026).
export const limpiarCedula = (valor) => {
  const texto = String(valor ?? '').toUpperCase();
  const esFalsa = texto.trimStart().startsWith('F');
  const digitos = texto.replace(/\D/g, '');
  return esFalsa ? `F${digitos.slice(0, 8)}` : digitos.slice(0, 9);
};

export default limpiarCedula;
